import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "dropdown_wrapper" }
const _hoisted_2 = ["placeholder", "value"]
const _hoisted_3 = {
  width: "20",
  version: "1.1",
  id: "Capa_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 490 490",
  "xml:space": "preserve",
  fill: "#68b2ff",
  height: "15",
  style: {"display":"block","cursor":"pointer"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("polygon", { points: "386.813,0 245,141.812 103.188,0 0,103.188 141.813,245 0,386.812 103.187,489.999 245,348.187 386.813,490\r\n\t490,386.812 348.187,244.999 490,103.187 " }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_20 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "col-12 dropdown_list" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "dropdown_list--item" }
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      class: "col-12 pretty_input opacity_input",
      type: "text",
      placeholder: _ctx.placeholder,
      value: _ctx.getCountryName(),
      onFocusin: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openList())),
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }, null, 40, _hoisted_2),
    (_ctx.list_showed && this.modelValue)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearInput && _ctx.clearInput(...args))),
          style: {"position":"absolute","right":"0","top":"50%","transform":"translateY(-50%)"}
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_20))
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCountries(), (country, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-12 dropdown_list--item_container",
            key: index
          }, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("h4", {
                class: "p-1",
                onClick: ($event: any) => (_ctx.pick_country(country))
              }, _toDisplayString(country.label), 9, _hoisted_24)
            ])
          ]))
        }), 128))
      ])
    ], 512), [
      [_vShow, _ctx.list_showed && !_ctx.filter_empty && _ctx.country_filter.length > 0]
    ])
  ]))
}